<template>
  <v-card outlined class="card-height d-flex">
    <v-card-text style="position: relative" class="p-0">
      <v-row class="h100 d-flex align-center" dense>
        <v-col cols="12">
          <a-plain-text-div>
            <template v-if="personnePhysique">
              <a-plain-text-component>
                {{ civilite | civilite }}
              </a-plain-text-component>
              <a-plain-text-component>
                {{ nom }}
              </a-plain-text-component>
              <a-plain-text-component>
                {{ prenom }}
              </a-plain-text-component>
            </template>
            <template v-if="personneMorale">
              <a-plain-text-component>
                {{ formeJuridique }}
              </a-plain-text-component>
              <a-plain-text-component>
                {{ denomination }}
              </a-plain-text-component>
            </template>
            <template v-if="personneReprise">
              <a-plain-text-component>
                {{ fonction }}
              </a-plain-text-component>
              <a-plain-text-component>
                {{ description }}
              </a-plain-text-component>
            </template>
          </a-plain-text-div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import mapPersonne from "./mapPersonne";
import makeValueData from "@/mixins/makeValueData";
export default {
  mixins: [makeValueData(mapPersonne)],
  computed: {
    personnePhysique() {
      return "physique" === this.type;
    },
    personneMorale() {
      return "morale" === this.type;
    },
    personneReprise() {
      return "reprise" === this.type;
    },
  },
};
</script>

<style scoped>
  .card-height {
    min-height: 68px;
  }
</style>
